import { render, staticRenderFns } from "./OperaPositionWindow.vue?vue&type=template&id=2e390e49"
import script from "./OperaPositionWindow.vue?vue&type=script&lang=js"
export * from "./OperaPositionWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports